<template>
    <div class="inline-block flex px-4 py-1 text-sm leading-5 truncate space-x-2 w-full" v-if="gamificationScoreCard">
        <div v-if="gamificationScoreCard.current_level !== null && settings.use_experience">
            <inertia-link :href="gamificationScoreCard.links.currency_points_show">
                <BadgePill>
                    <span v-if="!!settings.show_level">
                        {{ gamificationScoreCard.current_level }}
                    </span>
                    <span v-else> &bull; </span>
                </BadgePill>
            </inertia-link>
            <CurrencyPointsAnimation
                v-if="show"
                :order="gamificationScoreCard.student_id"
                :count="experience"
                :reference="`student_${gamificationScoreCard.student_id}`"
                @finished="reset()"
            />
            <CurrencyPointsAnimation
                v-if="show"
                :order="gamificationScoreCard.student_id"
                :count="gamificationScoreCard.particles.coins"
                :reference="`student_${gamificationScoreCard.student_id}`"
                @finished="reset()"
                type="coins"
            />
        </div>
        <div class="w-full">
            <ProgressBar :percent="gamificationScoreCard.percent" v-if="settings.use_experience">
                <span v-if="!!settings.show_experience"
                    >{{ gamificationScoreCard.current_level_experience_points }}/{{
                        gamificationScoreCard.width
                    }}&nbsp;</span
                >
                ({{ gamificationScoreCard.percent }}%)
            </ProgressBar>
            <ProgressBar
                v-show="settings.use_health && settings.show_health"
                :percent="gamificationScoreCard.health_percent"
                :title="`${gamificationScoreCard.health_total}/${gamificationScoreCard.health_max} (${gamificationScoreCard.health_percent}%)`"
                color="red"
                height="sm"
                class="mt-1"
            >
                &nbsp;
            </ProgressBar>
            <ProgressBarCurrentMax
                v-if="settings.use_energy"
                :current="gamificationScoreCard.energy_total"
                :min="0"
                :max="gamificationScoreCard.max_energy"
                :title="`${gamificationScoreCard.energy_total}/${gamificationScoreCard.max_energy} (${gamificationScoreCard.energy_percent})`"
                color="blue"
                height="xs"
                class="mt-1"
            >
                &nbsp;
            </ProgressBarCurrentMax>
        </div>
        <div v-if="!!settings.show_coins && settings.use_coins">
            <BadgePill color="yellow" :title="gamificationScoreCard.coins_total">
                {{ gamificationScoreCard.coins_short_display }}
            </BadgePill>
        </div>
    </div>
</template>

<script>
import BadgePill from '@/components/BadgePill.vue';
import ProgressBar from '@/components/Gamification/ProgressBar.vue';
import CurrencyPointsAnimation from '@/components/Gamification/CurrencyPointsAnimation.vue';
import { Howl } from 'howler';
import ProgressBarCurrentMax from './ProgressBarCurrentMax.vue';

export default {
    name: 'GamificationScoreCard',
    components: {
        ProgressBarCurrentMax,
        BadgePill,
        ProgressBar,
        CurrencyPointsAnimation,
    },
    props: {
        gamificationScoreCard: {
            required: false,
            type: Object,
        },
        settings: {
            type: Object,
            required: false,
            default: function () {
                return {
                    show_level: true,
                    show_experience: true,
                    show_coins: true,
                    show_health: true,
                    use_coins: true,
                    use_experience: true,
                    use_health: true,
                    use_energy: true,
                };
            },
        },
    },
    data() {
        return {
            show: false,
            batch: null,
            experience: this.gamificationScoreCard.particles.experience,
        };
    },
    created() {
        this.batch = this.gamificationScoreCard.particles.batch;
    },
    updated() {
        if (this.gamificationScoreCard.particles.active && this.batch !== this.gamificationScoreCard.particles.batch) {
            this.batch = this.gamificationScoreCard.particles.batch;
            if (this.gamificationScoreCard.particles.experience) {
                this.show = true;
                this.experience = this.gamificationScoreCard.particles.experience;
            }
            if (this.gamificationScoreCard.particles.coins) {
                this.show = true;
            }
            if (this.gamificationScoreCard.particles.health_lowered) {
                this.playBadBehaviourSound();
            }
        }
    },
    methods: {
        reset() {
            if (this.gamificationScoreCard.particles.experience) {
                const sound = new Howl({
                    src: ['/assets/gamification/currency/moo.mp3'],
                });
                sound.play();
            }
            if (this.gamificationScoreCard.particles.coins) {
                this.playCoinsSound();
            }

            this.show = false;
            this.experience = 0;
        },
        playBadBehaviourSound() {
            const sound = new Howl({
                src: ['/assets/gamification/currency/bad_behaviour.mp3'],
            });
            sound.play();
        },
        playCoinsSound() {
            const sound = new Howl({
                src: ['/assets/gamification/currency/coins.mp3'],
            });
            sound.play();
        },
    },
};
</script>
